import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import "./ManageUser.scss";

import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import AbunTable from "components/AbunTable/AbunTable";
import { Link, NavLink } from "react-router-dom";
import "./integration.scss";


export interface PublishedArticleTitle {
    id: number;
    post_id: string;
    media_id: string;
    title: string;
    slug: string;
    url: string;
    published_date: string; 
    gsc_position: number | null;
    article_uid: string;
  }

export default function PublishedArticles(props: { articles: Array<PublishedArticleTitle>}) {
    // ---------------------- NON STATE CONSTANTS ----------------------
    const pageSizes = [10, 50, 150, 250, 500];
    const [showPublishedArticles, setPublishedArticles] = useState(false);

    // ---------------------- TABLE COLUMN DEFS ----------------------
    const columnHelper = createColumnHelper<PublishedArticleTitle>();
    const columnDefs: ColumnDef<any, any>[] = [
        columnHelper.accessor((row: PublishedArticleTitle) => row.title, {
            id: 'title',
            header: "Article Title",
            cell: props => {
            return <NavLink to={`/view-article/${props.row.original.article_uid}`} >
                    {props.row.original.title}
                </NavLink>                    
            },
            enableGlobalFilter: true,
            enableSorting: true
        }),
        columnHelper.accessor((row: PublishedArticleTitle) => row.article_uid, {
            id: 'article_uid',
            header: "Article UID",
            cell: info => info.getValue(),
            enableGlobalFilter: true,
            enableSorting: true
        }),        
        columnHelper.accessor((row: PublishedArticleTitle) => row.published_date,{
            id: 'publishedDate',
            header: "Published Date",
            cell: props => {
                const value = props.row.original.published_date;
                if (!value) {
                    return "---";
                }
                const date = new Date(value);
                return date.toLocaleString();
            },
            enableGlobalFilter: false,
            enableSorting: true
        }),
        columnHelper.accessor((row: PublishedArticleTitle) => row.gsc_position, {
            id: 'gscPosition',
            header: "GSC Position",
            cell: props => {
                if (props.row.original.gsc_position){          
                    return props.row.original.gsc_position
                  }else{
                    return '-'
                  }    
            },
            enableGlobalFilter: false,
            enableSorting: true
        }),
        columnHelper.display({
            id: 'article_link',
            header: "Article Link",
            cell: props => {               
                return (
                    <Link target="_blank" to={props.row.original.url} className={"button is-primary"}>
                        View
                    </Link>
                )                
            },
            enableGlobalFilter: false,
        }),
    ]

    // ==============================================================
    // ---------------------- MAIN RENDER CODE ----------------------
    // ==============================================================
    return (
        <div className={"card w-100 mt-4"}>
            <header
				className="card-header is-clickable"
				onClick={() => setPublishedArticles(!showPublishedArticles)}
				>
				<p className="card-header-title">
                    Optimized Published Articles
				</p>
				<span className="card-header-icon">
				  <FontAwesomeIcon icon={showPublishedArticles ? faChevronDown : faChevronRight} />
				</span>
			</header>
            {showPublishedArticles && (
            <div className={"card-content"}>
                <div className={"content"}>
                    <div className={"all-users-container"}>
                        <AbunTable tableContentName={"Optimized Published Articles"}
                            tableData={props.articles}
                            columnDefs={columnDefs}
                            pageSizes={pageSizes}
                            initialPageSize={pageSizes[0]}
                            noDataText={"No Articel Found"}
                            enableSorting={true}
                            searchboxPlaceholderText={"Search articles..."} />
                    </div>
                </div>
            </div>
            )}
        </div>
    )
}
